import { absoluteCenter, stretchBlock } from '@anm/styles/helpers';
import { FC } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  ${stretchBlock}
  opacity: .9;
  background: #fff;
  z-index: 1;
`;
const Message = styled.div`
  ${absoluteCenter}
  width: 300px;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
`;

const DenyRoleChange: FC = () => (
  <Wrapper>
    <Message>
      To change your status
      <br /> assign <b>the Owner Role</b> to other User
    </Message>
  </Wrapper>
);

export default DenyRoleChange;
